import script from "./DatepickerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DatepickerComponent.vue?vue&type=script&setup=true&lang=js"

import "./DatepickerComponent.vue?vue&type=style&index=0&id=0847808f&lang=scss"

const __exports__ = script;

export default __exports__